import React from 'react';
import all from '../imgs/all.jpg'
import Navbar from './Navbar';
import '../css/about.css'
import Footer from './Footer';

const About = () => {
    return (
        <div>
            <Navbar/>
            <div className='about-all'>
                <div>
                    <h1>  Connecting all</h1>
                </div>
                <div className='about-content'>
                    <div className='about-description'>
                        <div className='topic'>
                            <h2> No border limitations just talent</h2>
                        </div>
                        <div className='des'>
                            <p> RemoteWorld is a platform that helps provide remote opportunities in software development</p>
                            <p> data curated from remotive</p>
                        </div>
                    </div>
                    <div className='about-image'>
                        <img className='image-all' src={all}/>
                    </div>
                </div>
            </div> 
            <Footer/>
        </div>
    );
};

export default About;